<template>
    <div id="app" :class="[this.$route.name, this.options.isWebView ? 'webview' : '', this.options.isDetailView ? 'webdetail' : '']">
        <router-view :store="store" :location="location" :options="options" :currentLanguage="currentLanguage" :houseColors="houseColors" v-on:changeLang="setLanguage" :jsondata="jsondata"></router-view>
    </div>
</template>

<script>
import Toolbar from '@/components/Toolbar.vue'
import * as nodelib from '@/nodes.js'
import router from './router'
import * as language from '@/translations'
import * as store from '@/store.js';
import axios from "axios";

export default {
    name: 'App',
    data() {
        return {
            timestring: '',
            datestring: '',
            location: {
                house: 1, level: 2
            },
            houseColors: [
                { id: 1, color: '#53A8D2'},
                { id: 3, color: '#01A888'},
                { id: 5, color: '#B66BA4'},
                { id: 7, color: '#F6AD50'},
                { id: 9, color: '#E5354C'},
            ],
            options: {
                // default values. These are loaded and set in localconfig.vue
                location: 'h13d',
                disableWeather: false,
                isWebView: false,
                isDetailView: false,
                returnToHome: true,
                enableCache: false,
                cacheDate: 'never',
                scaleFE: false,
                orientation: false,
                langcode: 'de',
                isPortrait: false,
                resetTimeout: 180000,
                debug: false,
            },
            currentLanguage: 'de',
            // store: store.store.state
        }
    },
    components: {
        Toolbar
    },
    props: ['jsondata'],
    created() {

        this.options.isPortrait = ( window.innerHeight > window.innerWidth ) ? true : false;

        let url = new URL(window.location.href);
        let querystartpoint = url.searchParams.get('startpoint');
 


        //overwrite local startpoint with query string

        let touchscreen = nodelib.nodes.find(x=> x.slug == querystartpoint);

        if ( querystartpoint && touchscreen ){
            this.options.location = touchscreen.id;
            this.options.orientation = touchscreen.orientation
        } else {
          this.options.orientation = nodelib.nodes.find(x=> x.id == this.options.location).orientation
        }

        //set website mode with query string
        let website = url.searchParams.get('website');

        if (website) {
            this.options.isWebView = true;
            this.options.disableWeather = true
        }

        if (url.searchParams.get('shopdetail')) {
            this.options.isWebView = true;
            this.options.disableWeather = true
            this.options.isDetailView = true
        }

        if (url.searchParams.get('debug')) {
            this.options.debug = true;
        }

        if (url.searchParams.get('returntohome')) {
            this.options.returnToHome = false;
        }

    },
    mounted() {
        let v = this;
        document.getElementById('app').addEventListener('click', function () {
            resetTimer();
        });
        window.theTimer = setTimeout(function () {
            reset()
        }, v.options.resetTimeout)

        function resetTimer() {
            console.log('timer reset');
            clearTimeout(window.theTimer);
            window.theTimer = setTimeout(function () {
                reset()
            }, v.options.resetTimeout)
        }

        function reset() {
            console.log('timeup');
            if (v.options.returnToHome){
                if ( v.$route.path.indexOf('backend') < 0  ){
                    v.$router.replace('/');
                    v.currentLanguage = 'de';
                }

            }

        }
    },
    computed: {
        getHouseColor(){
            return this.houseColors.find(x=> x.id == this.location.house).color
        },
        store(){
            let returnObject = {
                advertising: this.jsondata.advertising,
                shopnumbers: this.jsondata.shopnumbers,
                shops: this.jsondata.shops.filter(x=> x.shopnumbers && x.shopnumbers.length),
                exits: this.jsondata.exits,
                categories: this.jsondata.categories
            }
            if (this.currentLanguage === 'de'){
                returnObject.shops.forEach(function (el) {
                    el.name = el.name.replace('Level', 'Ebene');
                })

            }
            if (this.currentLanguage === 'en'){
                returnObject.shops.forEach(function (el) {
                    el.name = el.name.replace('Ebene', 'Level');
                })
                // returnObject.categories = this.jsondata.categoriesEN
            }
            return returnObject
        }
    },
    methods: {

        setLanguage(lang){
            this.currentLanguage = lang;
            this.options.langcode = lang;
        },
    }

}

</script>

<style lang="scss">

@import "styles/variables";

* {
    box-sizing: border-box;
}

body {
    padding: 0;
    margin: 0;
    /*padding-bottom: 120px;*/
    font-family: "Open Sans", sans-serif;
    background: gray;

}



</style>
